const labelKeySuffixes = {
  BANCONTACT_CARD: "bancontactCard",
  BANCONTACT_MOBILE: "bancontactMobile",
  CARD: "creditcard",
  CASH_ON_DELIVERY: "cashOnDelivery",
  FAKE: "fake",
  IDEAL: "ideal",
  KLARNA: "klarna",
  KLARNA_PAY_NOW: "klarna_pay_now",
  KLARNA_ACCOUNT: "klarna_account",
  MBWAY: "mbway",
  MOBILEPAY: "mobilepay",
  MULTIBANCO: "multibanco",
  ONEY: "oney",
  ONEY_3X: "oney_3x",
  ONEY_4X: "oney_4x",
  PAYPAL: "paypal",
  SEPA: "sepa",
  SWISH: "swish",
  APPLE_PAY: "applePay",
  GOOGLE_PAY: "googlePay",
  BIZUM: "bizum",
  INVOICE: "invoice",
  TWINT: "twint"
};
const globalTranslations = {
  BANCONTACT_CARD: "Bancontact Card",
  // debatable if this needs translation
  BANCONTACT_MOBILE: "Bancontact Mobile",
  // debatable if this needs translation
  FAKE: "Fake",
  IDEAL: "iDEAL",
  KLARNA: "Klarna",
  KLARNA_PAY_NOW: "Klarna Pay Now",
  KLARNA_ACCOUNT: "Klarna Account",
  // debatable if this needs translation
  MBWAY: "MB WAY",
  MOBILEPAY: "MobilePay",
  MULTIBANCO: "Multibanco",
  ONEY: "Oney",
  ONEY_3X: "Oney (3x)",
  ONEY_4X: "Oney (4x)",
  PAYPAL: "PayPal",
  SEPA: "SEPA",
  SWISH: "Swish",
  APPLE_PAY: "Apple Pay",
  GOOGLE_PAY: "Google Pay",
  BIZUM: "Bizum",
  INVOICE: "Invoice",
  TWINT: "Twint"
};
const getPaymentMethodLabel = (method, intl) => {
  const labelKey = `account.order.paymentMethod.${labelKeySuffixes[method]}`;
  if (intl.hasLabel(labelKey)) {
    return {
      label: intl.getLabel(labelKey),
      value: method
    };
  }
  const globalTranslation = globalTranslations[method];
  if (globalTranslation) {
    return { label: globalTranslation, value: method };
  }
  return {
    label: intl.getLabel(`account.order.paymentMethod.unknown`),
    value: method
  };
};
export {
  getPaymentMethodLabel,
  labelKeySuffixes
};
//# sourceMappingURL=get-payment-method-label.js.map
